<template>
    <div id="Wrapper"></div>
</template>
<script>

const gr_on_fastio_uri = process.env.VUE_APP_GRONFASTIO;

export default {
    name: 'Relogin',
    created: function(){
        if (sessionStorage.getItem('relogin_count')) {
            var reloginCount = Number(sessionStorage.getItem('relogin_count')) + 1;
            sessionStorage.setItem('relogin_count', reloginCount);
        } else {
            sessionStorage.setItem('relogin_count', 1);
        }
        let site_no = this.$store.getters['auth/getSiteNo']
        let relogin_uri = gr_on_fastio_uri + "login/authorize?app_id=livenext_app&on_success_url=" + encodeURIComponent(site_no)
        location.href = relogin_uri
    }
}
</script>
<style lang="scss">
</style>
